import * as Yup from 'yup';

export const leadValidationSchema = Yup.object().shape({
  assetId: Yup.string().required('Please select asset'),
  secondarySourceId: Yup.string()
  .when('id', {
    is: (id: string) => !id,
    then: Yup.string().required('Please select secondary source'),
    otherwise: Yup.string(),
  }),
});

export const overrideValidationSchema = Yup.object().shape({
  lenderCode: Yup.string().required('Please select lender'),
  rate: Yup.number().nullable().required(),
  term: Yup.number().nullable().required().max(255, 'Term must be 255 max'),
});

export const communicationValidationSchema = Yup.object().shape({
  type: Yup.string().required(),
  notes: Yup.string().required().max(500),
});
